import { Typography, TypographyProps } from "@material-ui/core"
import { PriceItem } from "api"
import { formatPrice } from "common/price"
import { Font } from "components/mapPages/showRooms/ShowRoomItem"
import React from "react"
import styled, { css } from "styled-components"
import { StyledContainer as StyledBottomBarContainer } from "../Container"
import LicensingFee from "../LicensingFee"
import NextStepButton from "../NextStepButton"

const StyledContainer = styled(StyledBottomBarContainer)`
  margin: 0;
  flex-direction: column;
  align-items: flex-start;
  max-width: 400px;
  border-radius: 5px;
`

const styledLabelCss = css`
  width: 86px;
  text-align: left;
  margin-left: 10px;
`

type StyledHeadingProps = React.FC<TypographyProps & { discount?: boolean }>
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const StyledHeading = styled<StyledHeadingProps>(({ discount, ...props }) => (
  <Typography {...props} />
)).attrs({ component: "h3" })`
  font-size: 0.875rem;
  ${(p) => p.discount && styledLabelCss}
`
const StyledPrice = styled(Typography)`
  font-family: ${Font.MazdaType};
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.08em;
`

const StyledPriceAndBtnWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`

const TotalPriceDesktop = ({ price }: { price: PriceItem }) => (
  <StyledContainer>
    <StyledPriceAndBtnWrapper>
      <div>
        <StyledPrice aria-label="מחיר נוכחי">
          {formatPrice(price.totalPrice)}
        </StyledPrice>
      </div>
      <NextStepButton />
    </StyledPriceAndBtnWrapper>

    <LicensingFee />
  </StyledContainer>
)

export default TotalPriceDesktop
